<template>
  <section id="Home">
    <v-container fluid>
      <HomeALanding />
    </v-container>
    <HomeBAbout class="py-16" />
    <HomeCVideo class="py-16" />
    <HomeDServices class="py-16" />
    <HomeESay class="py-16" />
    <HomeFPosition class="py-16" />
  </section>
</template>

<script>
import HomeALanding from "./ALanding.vue";
import HomeBAbout from "./BAbout.vue";
import HomeCVideo from "./CVideo.vue";
import HomeDServices from "./DServices.vue";
import HomeESay from "./ESay.vue";
import HomeFPosition from "./FPosition.vue";
export default {
  components: {
    HomeALanding,
    HomeBAbout,
    HomeCVideo,
    HomeDServices,
    HomeESay,
    HomeFPosition,
  },
};
</script>
